import { routeConstants } from "constants/routeConstants";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "slice";

export const useHighLight = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);
    const [availabilityStatus, setAvailabilityStatus] = useState("Available");
    const navigateTo = useNavigate();

    const { userId } = useParams();
    const { user_id } = useAppSelector((state) => state.userAuth);

    const handleShare = () => {
        let url = window.location.href;
        if (userId) {
            url = url + "/" + userId;
        } else {
            url = url + "/" + user_id;
        }
        window.navigator.clipboard.writeText(url);
        setLinkCopied(true);
    };

    useEffect(() => {
        if (linkCopied) {
            setTimeout(() => setLinkCopied(false), 3000);
        }
    }, [linkCopied]);

    const toggleModal = () => setIsModalOpen((prev) => !prev);
    const handleChange = (val: string) => {
        setAvailabilityStatus(val);
    };

    const handleEditProfile = () => {
        navigateTo(
            routeConstants.profile.editProfile.root +
                routeConstants.profile.editProfile.personalDetails
        );
    };

    return {
        isModalOpen,
        availabilityStatus,
        handleEditProfile,
        handleShare,
        linkCopied,
        toggleModal,
        handleChange,
    };
};
